const isEmpty = (graphqlObject: any) => {
   const fields = Object.keys(graphqlObject || {}).filter(key => {
      return !['__typename'].includes(key)
   })
   return fields.length === 0
}

export const GraphQL = {
   isEmpty
}